import * as React from "react";
import { Avatar, Popover } from "@material-ui/core";
import IconButton from "../../IconButton";
import Separator from "../../Separator";
import AppSwitcherMini from "../../AppSwitcherMini";
import LogoIMG from "../../../assets/logo/logo-tc.png";

import "./index.scss";

const SideToolbar = (props) => {
  const [anchorAvatarProfile, setAnchorAvatarProfile] = React.useState(null);
  const [appSwitcherAnchor, setAppSwitcherAnchor] = React.useState(null);

  const handleClickAvatarProfile = (event) => {
    setAnchorAvatarProfile(event.currentTarget);
  };

  const handleAppSwitcherClick = (event) => {
    setAppSwitcherAnchor(event.currentTarget);
  };

  const handleCloseAvatarProfile = () => {
    setAnchorAvatarProfile(null);
  };

  const handleCloseAppSwitcher = () => {
    setAppSwitcherAnchor(null);
  };

  const OpenAnchorAvatarProfile = Boolean(anchorAvatarProfile);
  const openAnchorAppSwitcher = Boolean(appSwitcherAnchor);
  const {
    backgroundColor,
    logo,
    renderTopActions,
    renderBottomActions,
    appSwitcherEnabled,
    renderAccountDetails,
  } = props;

  return (
    <>
      <div className="first-sidenav" style={{ backgroundColor: backgroundColor }}>
        <div className="first-sidenav-app-logo">
          {" "}
          <Avatar style={{ width: "32px", height: "32px" }} alt="profile" src={LogoIMG} />
        </div>

        <div className="first-sidenav-icon-menu">
          <div className="first-sidenav-icon-menu-top">
            {renderTopActions ? renderTopActions() : null}
          </div>
          <div className="first-sidenav-icon-menu-bottom">
            {renderBottomActions ? renderBottomActions() : null}
            <Separator variant="vertical" />
            <div>
              <a href="#/settings" style={{ textDecoration: "none" }} id="example-button">
                <IconButton>
                  <i className="material-icons">error</i>
                </IconButton>
              </a>
            </div>
            <Separator variant="vertical" />
            <div>
              <a href="#/settings" style={{ textDecoration: "none" }} id="example-button">
                <IconButton>
                  <i className="material-icons">settings</i>
                </IconButton>
              </a>
            </div>

            {appSwitcherEnabled ? (
              <>
                <Separator variant="vertical" />
                <IconButton onClick={handleAppSwitcherClick}>
                  <i className="material-icons">apps</i>
                </IconButton>
                <Popover
                  style={{ left: "-10px" }}
                  open={openAnchorAppSwitcher}
                  anchorEl={appSwitcherAnchor}
                  onClose={handleCloseAppSwitcher}
                  anchorOrigin={{
                    vertical: "center",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "center",
                    horizontal: "left",
                  }}
                >
                  <AppSwitcherMini data={props.apps ? props.apps : []} />
                </Popover>
              </>
            ) : null}
          </div>
        </div>

        <div className="first-sidenav-avatar" onClick={handleClickAvatarProfile}>
          <div className="first-sidenav-app-logo">{logo}</div>
        </div>
        <Popover
          style={{ left: "-10px" }}
          open={OpenAnchorAvatarProfile}
          anchorEl={anchorAvatarProfile}
          onClose={handleCloseAvatarProfile}
          anchorOrigin={{
            vertical: "center",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
        >
          {renderAccountDetails ? renderAccountDetails() : null}
        </Popover>
      </div>
    </>
  );
};

export default SideToolbar;
